(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kl-card"] && !Shopify.designMode) return;
  try {
    /**
   * Gemeinsamer Warenkorb-Zugriff für die Startseiten-Bausteine.
   * @typedef {Object} KLLineItem
   * @property {number} id
   * @property {number} quantity
   */
  window.KLCart = window.KLCart || {
    /**
     * @param {KLLineItem[]} items
     */
    async add(items) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('cart-add-failed');

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'kl-home',
            data: { source: 'kl-home', itemCount: cart.item_count },
          },
        })
      );
      return cart;
    },
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-kc-add]');
    if (!button || button.disabled) return;

    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';

    try {
      await window.KLCart.add([{ id: Number(button.dataset.variant), quantity: 1 }]);
      button.textContent = 'Im Warenkorb ✓';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = label;
      }, 2400);
    } catch (error) {
      button.disabled = false;
      button.textContent = label;
      const link = button.closest('.kc')?.querySelector('.kc__title');
      if (link) window.location.href = link.href;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
